/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DashboardDto } from '../models/dashboard-dto';
import { getDashboard } from '../fn/dashboard/get-dashboard';
import { GetDashboard$Params } from '../fn/dashboard/get-dashboard';

@Injectable({ providedIn: 'root' })
export class GeneratedDashboardService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDashboard()` */
  static readonly GetDashboardPath = '/api/dashboard';

  /**
   * Gets dashboard information.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDashboard()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDashboard$Response(params?: GetDashboard$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardDto>> {
    return getDashboard(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets dashboard information.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDashboard$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDashboard(params?: GetDashboard$Params, context?: HttpContext): Observable<DashboardDto> {
    return this.getDashboard$Response(params, context).pipe(
      map((r: StrictHttpResponse<DashboardDto>): DashboardDto => r.body)
    );
  }

}
